{
  "PROFILE_SETTINGS": {
    "LINK": "Profiilin asetukset",
    "TITLE": "Profiilin asetukset",
    "BTN_TEXT": "Päivitä profiili",
    "DELETE_AVATAR": "Delete Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar has been deleted successfully",
    "AVATAR_DELETE_FAILED": "There is an error while deleting avatar, please try again",
    "UPDATE_SUCCESS": "Your profile has been updated successfully",
    "PASSWORD_UPDATE_SUCCESS": "Salasanasi on vaihdettu onnistuneesti",
    "AFTER_EMAIL_CHANGED": "Profiilisi on päivitetty onnistuneesti, ole hyvä ja kirjaudu uudelleen kun kirjautumistunnuksesi muuttuvat",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Sähköpostiallekirjoituksen kuva",
        "HINT": "Käytetään sähköpostiallekirjoituksissa. {'{{'}email_signature_picture{'}}'} korvataan tämän kuvan URL-osoitteella (ei img-tunnisteella) — käytä sitä kuvan lähteenä (img-tunnisteen src-attribuuttina) allekirjoituksessasi tai postilaatikon allekirjoituksessa. Jos sitä ei ole asetettu, mitään ei lisätä.",
        "DELETE_SUCCESS": "Sähköpostiallekirjoituksen kuva on poistettu onnistuneesti",
        "DELETE_FAILED": "Sähköpostiallekirjoituksen kuvan poistamisessa tapahtui virhe, yritä uudelleen"
      },
      "AVATAR": "Profiilikuva",
      "ERROR": "Korjaa lomakkeen virheet",
      "REMOVE_IMAGE": "Poista",
      "UPLOAD_IMAGE": "Lataa kuva",
      "UPDATE_IMAGE": "Päivitä kuva",
      "PROFILE_SECTION": {
        "TITLE": "Profiili",
        "NOTE": "Sähköpostiosoitteesi on identiteettisi ja sitä käytetään sisäänkirjautumiseen."
      },
      "SEND_MESSAGE": {
        "TITLE": "Hotkey to send messages",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Your settings have been updated successfully",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Mukauta hallintapaneelisi ulkoasua.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Default",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Hallintapaneelin kieli",
          "NOTE": "Ohita tilin kieli vain omassa hallintapaneelissasi. Jätä tyhjäksi käyttääksesi tilin oletuskieltä.",
          "USE_ACCOUNT_DEFAULT": "Käytä tilin oletusta",
          "API_SUCCESS": "Hallintapaneelin kielesi on päivitetty onnistuneesti"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Viestin kieli",
          "NOTE": "Valitse, näytetäänkö alkuperäiset viestit vai niiden käännökset",
          "ORIGINAL": "Alkuperäinen",
          "TRANSLATED": "Käännetty"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Liittämisen toiminta",
          "NOTE": "Valitse, miten liitetty sisältö käsitellään viestejä kirjoitettaessa",
          "UPDATE_SUCCESS": "Liittämisasetuksesi on päivitetty onnistuneesti",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Säilytä kaikki muotoilu",
              "DESCRIPTION": "Säilytä kaikki muotoilu, mukaan lukien taulukot, tyylit ja muut HTML-elementit sisältöä liitettäessä."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Vain teksti ja linkit",
              "DESCRIPTION": "Muunna pelkäksi tekstiksi, mutta säilytä napsautettavat linkit sisältöä liitettäessä."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Vain pelkkä teksti",
              "DESCRIPTION": "Poista kaikki muotoilu ja muunna pelkäksi tekstiksi sisältöä liitettäessä."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Vastauskentän korkeus",
          "NOTE": "Aseta vastauskentän vähimmäiskorkeus prosentteina näytön korkeudesta. Koskee vain sähköpostikeskusteluja.",
          "UPDATE_SUCCESS": "Vastauskentän korkeusasetus on päivitetty onnistuneesti",
          "PERCENT_LABEL": "Korkeus (% näytön korkeudesta)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Oletus",
              "DESCRIPTION": "Vastauskenttä alkaa pienenä ja kasvaa kirjoittaessasi."
            },
            "CUSTOM": {
              "HEADING": "Mukautettu",
              "DESCRIPTION": "Vastauskentän korkeus on aina vähintään valittu prosenttiosuus näytön korkeudesta."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Siirry automaattisesti seuraavaan keskusteluun",
        "NOTE": "Siirry automaattisesti seuraavaan avoimeen keskusteluun nykyisen ratkaisemisen jälkeen",
        "UPDATE_SUCCESS": "Automaattisen siirtymisen asetus päivitetty onnistuneesti"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personal message signature",
        "DESCRIPTION": "Luo yksilöllinen viestiallekirjoitus, joka näkyy jokaisen lähettämäsi sähköpostin lopussa. Voit myös sisällyttää kuvan.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Save message signature",
        "API_ERROR": "Couldn't save signature! Try again",
        "API_SUCCESS": "Signature saved successfully",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Message Signature",
        "ERROR": "Message Signature cannot be empty",
        "PLACEHOLDER": "Insert your personal message signature here."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Salasana",
        "NOTE": "Salasanan vaihtaminen kirjaa sinut ulos muilta laitteilta.",
        "BTN_TEXT": "Change password"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Access Token",
        "NOTE": "Tätä tunnusta voidaan käyttää, jos olet rakentamassa API-pohjaista integraatiota",
        "COPY": "Kopioi",
        "REGENERATE": "Luo uudelleen",
        "REGENERATE_SUCCESS": "Käyttöoikeustunnus luotiin uudelleen onnistuneesti. Päivitä vanhaa tunnusta käyttävät integraatiot.",
        "REGENERATE_CONFIRM_TITLE": "Luodaanko käyttöoikeustunnus uudelleen?",
        "REGENERATE_CONFIRM_MESSAGE": "Tämä mitätöi nykyisen tunnuksen. Vanhaa tunnusta käyttävät integraatiot lakkaavat toimimasta."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome-laajennus",
        "NOTE": "Asenna Chrome-laajennuksemme saadaksesi monipuoliset ilmoitukset saapuvista puheluista.",
        "INSTALL_BUTTON": "Asenna laajennus",
        "ALREADY_INSTALLED": "Laajennus asennettu"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "None",
          "MINE": "Assigned",
          "ALL": "Kaikki",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "None",
          "ASSIGNED": "Assigned Conversations",
          "ALL_CONVERSATIONS": "All Conversations"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Sähköposti-ilmoitukset",
        "NOTE": "Päivitä sähköposti-ilmoitusasetukset täällä",
        "CONVERSATION_ASSIGNMENT": "Lähetä sähköposti-ilmoitus, kun keskustelu on määritetty minulle",
        "CONVERSATION_CREATION": "Lähetä sähköposti-ilmoitus, kun keskustelu on määritetty minulle",
        "CONVERSATION_MENTION": "Send email notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Lähetä sähköposti-ilmoitus, kun uusi viesti saapuu minulle osoitettuun keskusteluun",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Sähköposti",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Uusi viesti luotiin keskustelussa, jossa ei ole saatavilla edustajaa",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Salli push-ilmoitukset puhelun aikana",
        "TEST_PUSH": "Testaa",
        "TESTING": "Testataan...",
        "TEST_PUSH_DESCRIPTION": "Lähetä testi-ilmoituksia asetustesi varmistamiseksi",
        "TEST_NOTIFICATION_ERROR": "Testi-ilmoituksen lähettäminen epäonnistui. Yritä uudelleen.",
        "TEST_LOCAL_TITLE": "Testi-ilmoitus (paikallinen)",
        "TEST_LOCAL_BODY": "Tämä on paikallinen selainilmoitus. Jos näet tämän, selainilmoitukset toimivat!"
      },
      "API": {
        "UPDATE_SUCCESS": "Ilmoitusasetuksesi päivitetään onnistuneesti",
        "UPDATE_ERROR": "Asetuksia päivitettäessä tapahtui virhe. Ole hyvä ja yritä uudelleen"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push-ilmoitukset",
        "NOTE": "Päivitä push-ilmoitusasetukset täällä",
        "CONVERSATION_ASSIGNMENT": "Lähetä push-ilmoitus, kun keskustelu on määritetty minulle",
        "CONVERSATION_CREATION": "Lähetä push-ilmoitus, kun keskustelu on määritetty minulle",
        "CONVERSATION_MENTION": "Send push notifications when you are mentioned in a conversation",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Lähetä push-ilmoitus, kun uusi viesti saapuu minulle osoitettuun keskusteluun",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Tämän selaimen push-ilmoitukset on otettu käyttöön.",
        "REQUEST_PUSH": "Ota push-ilmoitukset käyttöön",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profiilikuva"
      },
      "NAME": {
        "LABEL": "Koko nimesi",
        "ERROR": "Anna kelvollinen koko nimi",
        "PLACEHOLDER": "Syötä koko nimesi"
      },
      "DISPLAY_NAME": {
        "LABEL": "Näyttönimi",
        "ERROR": "Anna kelvollinen näyttönimi",
        "PLACEHOLDER": "Näyttöniminimi, joka näytetään keskusteluissa"
      },
      "POSITION": {
        "LABEL": "Asema",
        "ERROR": "Anna kelvollinen asema",
        "PLACEHOLDER": "Anna asemasi"
      },
      "CUSTOM_LINE": {
        "LABEL": "Mukautettu rivi",
        "ERROR": "Anna kelvollinen mukautettu rivi",
        "PLACEHOLDER": "Anna mukautettu rivisi"
      },
      "AVAILABILITY": {
        "LABEL": "Saatavuus",
        "STATUS": {
          "ONLINE": "Paikalla",
          "BUSY": "Varattu",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Sähköpostin esikatselumuoto keskustelulistassa",
        "NOTE": "Valitse, mitä näytetään keskustelulistassa postilaatikoiden keskusteluille",
        "SUBJECT": "Aihe",
        "SUBJECT_WITH_NOTE": "Aihe ja viimeisin viesti, jos se on sisäinen merkintä",
        "UPDATE_SUCCESS": "Sähköpostin esikatseluasetus päivitetty onnistuneesti"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Poista pikanäppäimet käytöstä",
        "NOTE": "Poista kaikki pikanäppäimet käytöstä koko sovelluksessa",
        "UPDATE_SUCCESS": "Pikanäppäinasetus päivitetty onnistuneesti"
      },
      "FOLDER_ORDER": {
        "TITLE": "Kansioiden järjestys",
        "NOTE": "Mukauta järjestystä, jossa kansiot (mukautetut näkymät) näkyvät sivupalkissa. Järjestä vetämällä ja pudottamalla.",
        "NO_FOLDERS": "Mukautettuja kansioita ei löytynyt. Luo kansioita järjestääksesi keskustelusi."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Sivupalkin asetukset",
        "NOTE": "Mukauta, mitkä osiot näkyvät keskustelujen sivupalkissa.",
        "SAVE_BUTTON": "Tallenna asetukset",
        "UPDATE_SUCCESS": "Sivupalkin asetukset päivitetty onnistuneesti",
        "UPDATE_ERROR": "Sivupalkin asetusten päivittämisessä tapahtui virhe, yritä uudelleen",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Kaikki keskustelut",
          "ALL_CONVERSATIONS_DESC": "Näytä Kaikki keskustelut -valikkokohde sivupalkissa",
          "INBOX": "Saapuneet-kansio",
          "INBOX_DESC": "Näytä pääsaapuneet-kansio lukemattomine ilmoituksineen",
          "CONVERSATION_GROUPS": "Maininnat ja huomiotta jääneet",
          "CONVERSATION_GROUPS_DESC": "Näytä Maininnat- ja Huomiotta jääneet -keskusteluryhmät",
          "FOLDERS": "Kansiot",
          "FOLDERS_DESC": "Näytä mukautetut näkymät (kansiot) järjestettyjä keskusteluja varten",
          "TEAMS": "Tiimit",
          "TEAMS_DESC": "Näytä keskustelut suodatettuna tiimimäärityksen mukaan",
          "CHANNELS": "Saapuneet-kansiot",
          "CHANNELS_DESC": "Näytä keskustelut suodatettuna saapuneet-kansion mukaan",
          "LABELS": "Tunnisteet",
          "LABELS_DESC": "Näytä keskustelut suodatettuna tunnisteiden mukaan"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Puhelinasetukset",
        "NOTE": "Anna kirjautumistiedot puhelinvaihdejärjestelmääsi.",
        "USERNAME": "Käyttäjätunnus",
        "PASSWORD": "Salasana",
        "SUBMIT": "Tallenna",
        "USERNAME_INVALID": "Käyttäjätunnus voi sisältää vain kirjaimia, numeroita sekä merkkejä . _ - + — ei välilyöntejä eikä sähköpostiosoitetta.",
        "API": {
          "USERNAME_INVALID": "Käyttäjätunnus ei ole kelvollinen SIP-käyttäjätunnus. Käytä vain kirjaimia, numeroita sekä merkkejä . _ - + — ei välilyöntejä eikä sähköpostiosoitetta.",
          "USERNAME_TAKEN": "Tämä käyttäjätunnus on jo toisen tämän tilin edustajan käytössä."
        }
      },
      "EMAIL": {
        "LABEL": "Sinun sähköpostiosoitteesi",
        "ERROR": "Ole hyvä ja syötä validi sähköposti",
        "PLACEHOLDER": "Sähköposti, joka näytetään keskusteluissa"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Current password",
        "ERROR": "Please enter the current password",
        "PLACEHOLDER": "Please enter the current password"
      },
      "PASSWORD": {
        "LABEL": "New password",
        "ERROR": "Anna salasana jonka pituus on 6 tai enemmän",
        "PLACEHOLDER": "Anna uusi salasana"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Vahvista salasana",
        "ERROR": "Salasanat eivät täsmää",
        "PLACEHOLDER": "Please re-enter your new password"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Vaihda",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Ilmoita virheestä",
    "SELECTOR_SUBTITLE": "Valitse tili tästä luettelosta",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Ilmoita virheestä",
    "DESCRIPTION_LABEL": "Ongelman kuvaus",
    "DESCRIPTION_PLACEHOLDER": "Kuvaile kohtaamaasi ongelmaa...",
    "SUBMIT": "Lähetä ilmoitus",
    "SUBMITTING": "Lähetetään...",
    "CANCEL": "Peruuta",
    "SUCCESS": "Virheilmoitus lähetetty onnistuneesti. Kiitos!",
    "VALIDATION_ERROR": "Kuvaile ongelma ennen lähettämistä"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "päivää jäljellä.",
    "TRAIL_BUTTON": "Osta nyt",
    "DELETED_USER": "Deleted User",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Account Suspended",
      "MESSAGE": "Your account is suspended. Please reach out to the support team for more information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopioi",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Koodi kopioitu leikepöydälle onnistuneesti"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Show More",
      "SHOW_LESS": "Show Less"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Lataa",
      "UPLOADING": "Lähetetään...",
      "INSTAGRAM_STORY_UNAVAILABLE": "This story is no longer available.",
      "RECORDING_UNAVAILABLE": "Tämä tallenne ei ole enää saatavilla.",
      "DELETE_RECORDING": {
        "BUTTON": "Poista puhelun tallenne",
        "TITLE": "Poistetaanko puhelun tallenne?",
        "DESCRIPTION": "Kaikki tämän puhelun tallenteet poistetaan pysyvästi puhelinjärjestelmästä, eikä niitä voi palauttaa. Puhelun litteraatti ja yhteenveto säilyvät.",
        "CONFIRM": "Poista",
        "SUCCESS": "Puhelun tallenne poistettu",
        "ERROR": "Puhelun tallenteen poistaminen epäonnistui. Yritä uudelleen."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "See on map"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Lähetä"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Vahvistetaan...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Lisää kansio"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Currently viewing:",
    "SWITCH": "Switch",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Keskustelut",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "All Conversations",
    "MENTIONED_CONVERSATIONS": "Mentions",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattended",
    "REPORTS": "Raportit",
    "SETTINGS": "Asetukset",
    "CONTACTS": "Yhteystiedot",
    "DATA_ASSISTANT": "Data-avustaja",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Koti",
    "AGENTS": "Edustajat",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "WhatsApp-pohjat",
    "BLOCKED_DOMAINS": "ROSKAPOSTI",
    "INBOXES": "Kansiot",
    "NOTIFICATIONS": "Ilmoitukset",
    "CANNED_RESPONSES": "Tallennetut vastaukset",
    "INTEGRATIONS": "Integraatiot",
    "PROFILE_SETTINGS": "Profiilin asetukset",
    "ACCOUNT_SETTINGS": "Tilin asetukset",
    "APPLICATIONS": "Applications",
    "LABELS": "Tunnisteet",
    "CUSTOM_ATTRIBUTES": "Mukautetut attribuutit",
    "AUTOMATION": "Automation",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Billing",
    "CUSTOM_VIEWS_FOLDER": "Folders",
    "CUSTOM_VIEWS_SEGMENTS": "Segments",
    "ALL_CONTACTS": "All Contacts",
    "TAGGED_WITH": "Tagged with",
    "NEW_LABEL": "New label",
    "NEW_TEAM": "New team",
    "NEW_INBOX": "New inbox",
    "REPORTS_CONVERSATION": "Keskustelut",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Campaigns",
    "ONGOING": "Ongoing",
    "ONE_OFF": "One off",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Botti",
    "REPORTS_AGENT": "Edustajat",
    "REPORTS_LABEL": "Tunnisteet",
    "REPORTS_INBOX": "Inbox",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Puhelin",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Yleiskatsaus",
    "WALLBOARD_QUEUES": "Jonot",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Raportit",
    "NO_WAITING_CALLERS": "ei odottavia soittajia",
    "WAITING_CALLERS": "{count} soittajaa odottaa",
    "SET_AVAILABILITY_TITLE": "Set yourself as",
    "SET_YOUR_AVAILABILITY": "Set your availability",
    "AVAILABILITY_IMPERSONATING": "Lukittu, kun olet kirjautunut tänä käyttäjänä",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Uusi keskustelu",
    "DRAFT": "Luonnos",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Overview",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Categories",
      "LOCALES": "Locales",
      "SETTINGS": "Asetukset",
      "DICTIONARY": "Sanasto"
    },
    "CHANNELS": "Kanavat",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Read docs"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Estetyt verkkotunnukset ja yhteystiedot",
    "DESCRIPTION": "Luettelo tämän tilin estetyistä sähköpostin verkkotunnuksista.",
    "NO_BLOCKED_DOMAINS": "Estettyjä verkkotunnuksia ei löytynyt.",
    "BLOCKED_CONTACTS_BTN": "Estetyt yhteystiedot"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Billing",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Current Plan",
      "PLAN_NOTE": "You are currently subscribed to the **{plan}** plan with **{quantity}** licenses",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Manage your subscription",
      "DESCRIPTION": "View your previous invoices, edit your billing details, or cancel your subscription.",
      "BUTTON_TXT": "Go to the billing portal"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Need help?",
      "DESCRIPTION": "Do you face any issues in billing? We are here to help.",
      "BUTTON_TXT": "Keskustele kanssamme"
    },
    "NO_BILLING_USER": "Your billing account is being configured. Please refresh the page and try again."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Voi ei! Emme löytäneet yhtään tiliä. Luo uusi tili jatkaaksesi.",
    "NEW_ACCOUNT": "Uusi tili",
    "SELECTOR_SUBTITLE": "Luo uusi tili",
    "API": {
      "SUCCESS_MESSAGE": "Tilin luominen onnistui",
      "EXIST_MESSAGE": "Tili on jo olemassa",
      "ERROR_MESSAGE": "Yhteyden muodostaminen Woot-palvelimelle ei onnistunut, yritä myöhemmin uudelleen"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Yrityksen nimi",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Lähetä",
      "CANCEL": "Peruuta"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Open conversation",
      "RESOLVE_AND_NEXT": "Resolve and move to next",
      "NAVIGATE_DROPDOWN": "Navigate dropdown items",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "ADD_ATTACHMENT": "Add Attachment",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Toggle Sidebar",
      "GO_TO_REPORTS_SIDEBAR": "Go to Reports sidebar",
      "MOVE_TO_NEXT_TAB": "Move to next tab in conversation list",
      "GO_TO_SETTINGS": "Go to Settings",
      "SWITCH_TO_PRIVATE_NOTE": "Switch to Private Note",
      "SWITCH_TO_REPLY": "Switch to Reply",
      "TOGGLE_SNOOZE_DROPDOWN": "Toggle snooze dropdown",
      "AI_ASSIST_MENU": "Tekoälyapu",
      "AI_ASSIST_GRAMMAR": "Korjaa kielioppi",
      "AI_ASSIST_UNIFY_LANG": "Yhtenäistä viestin kieli"
    }
  }
}
